
import {Action, Actions, Coords, Region} from './types';

export const actions = (dispatch: React.Dispatch<Action>): Actions => ({
	setCoords: (coords?: Coords, label?: string) => dispatch({
		type: 'SET-COORDS',
		coords,
		label,
	}),
	setRegion: (region?: Region) => dispatch({
		type: 'SET-REGION',
		region,
	}),
	clearSearch: () => dispatch({
		type: 'CLEAR-SEARCH',
	}),
	toggleMap: () => dispatch({
		type: 'TOGGLE-MAP',
	}),
	setSort: (sort) => dispatch({
		type: 'SET-SORT',
		sort,
	}),
});
